import { Page } from 'types';
import PageComponents from '~/components/page-components';
import PageMetaData from '~/components/page-meta-data';
import styles from '~/styles/pages/index.module.scss';

interface Props {
  page: Page;
}
export default function PageLayout({ page }: Props) {
  return (
    <>
      <PageMetaData
        title={page.meta.title}
        description={page.meta.description}
        twitterCard="app"
        photoUrl={page.meta.mainImage}
      />
      <section role="main" className={styles.container}>
        <PageComponents components={page.components} />
      </section>
    </>
  );
}